<template>
  <div>
    <div class="relative z-10 container mx-auto h-auto laptop:mt-36 flex-col flex md:justify-between">
      <div class="absolute z-20 p-1 laptop:ml-12 fullhd:ml-0 px-5 md:p-10 laptop:p-0 pointer-events-none">
        <MARSHeading><div v-html="$t('animation.hero')" /></MARSHeading>
      </div>
      <div class="flex flex-row-reverse z-10 p-1 laptop:ml-12 fullhd:ml-0 px-5 md:p-10 laptop:p-0 pointer-events-none">
        <video autoplay muted loop="true" playsinline>
          <source src="~/assets/img/video/caff.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-10">
        <img loading="lazy" class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
      </div>
    </div>

    <div class="container align-middle mx-auto flex flex-col laptop:flex-row">
      <div class="w-full flex laptop:w-6/12 laptop:ml-0 laptop: fullhd: flex-col laptop:justify-around md:px-10 ">
        <div class="w-9/10 text-left align-middle laptop:pl-16 laptop:pr-10 md: px-4 md:my-10 sm: mb-0 sm: mt-10 sm: py-4 sm: pl-4">
          <MARSTitle margin-bottom="mb-3 lg:mb-12"><div v-html="$t('animation.sell-more')" /></MARSTitle>
          <p class="md:font-medium sm: font-medium md:text-lg align-middle laptop:text-slg laptop:leading-7 md:leading-8 sm: leading-6.5" v-html="$t('animation.sell-more-description-1')" />
        </div>
      </div>
      <div class="relative w-full flex laptop:w-6/12 laptop:ml-0  laptop:p-0 fullhd: flex-col laptop:justify-around md:px-8">
        <video autoplay muted loop="true" playsinline>
          <source src="~/assets/img/video/caff2.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="transition duration-1000 ease-in-out hover:transition-opacity timing-function: cubic-bezier(0.4, 0, 0.2, 1) absolute inset-0 object-cover w-100 h-160" />
      </div>
    </div>

    <div class="container mx-auto flex flex-col laptop:flex-row">
      <div class="relative w-full flex laptop:w-6/12 laptop:ml-0 laptop:p-0 fullhd: flex-col laptop:justify-around md:px-8 ">
        <video autoplay muted loop="true" playsinline>
          <source src="~/assets/img/video/travolta.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="transition duration-1000 ease-in-out hover:transition-opacity timing-function: cubic-bezier(0.4, 0, 0.2, 1) absolute inset-0 object-cover w-100 h-160" />
      </div>

      <div class="w-full flex justify-center laptop:w-6/12 laptop:ml-0  laptop:p-0 fullhd: flex-col laptop:justify-around md:px-8 ">
        <img loading="lazy" class="w-9/10" src="~/assets/img/fabb-cioc.webp" alt="Come funziona?">
      </div>
    </div>

    <div class="container align-middle mx-auto flex flex-col laptop:flex-row">
      <div class="w-full flex laptop:w-6/12 laptop:ml-0 laptop: fullhd: flex-col laptop:justify-around md:px-10 ">
        <div class="w-9/10 text-left align-middle laptop:pl-16 laptop:pr-10 md: px-4 md:my-10 sm: mb-0 sm: mt-10 sm: py-4 sm: pl-4">
          <MARSTitle margin-bottom="mb-3 lg:mb-12"><div v-html="$t('animation.easy-1')" /></MARSTitle>
          <p class="md:font-medium  sm: font-medium md:text-lg align-middle laptop:text-slg laptop:leading-7 md:leading-8 sm: leading-6.5" v-html="$t('animation.easy-description-1')" />
        </div>
      </div>

      <div class="relative w-full flex laptop:w-6/12 laptop:ml-0  laptop:p-0 fullhd: flex-col laptop:justify-around md:px-8 ">
        <video autoplay muted loop="true" playsinline>
          <source src="~/assets/img/video/omino.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="transition duration-1000 ease-in-out hover:transition-opacity timing-function: cubic-bezier(0.4, 0, 0.2, 1) absolute inset-0 object-cover w-100 h-160" />
      </div>
    </div>

    <div class="container mx-auto flex flex-col laptop:flex-row">
      <div class="relative w-full flex laptop:w-6/12 laptop:ml-0  laptop:p-0 fullhd: flex-col laptop:justify-around laptop:order-first md:order-last md:px-8 ">
        <video autoplay muted loop="true" playsinline>
          <source src="~/assets/img/video/poster.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="transition duration-1000 ease-in-out hover:transition-opacity timing-function: cubic-bezier(0.4, 0, 0.2, 1) absolute inset-0 object-cover w-100 h-160" />
      </div>

      <div class="w-full flex laptop:w-6/12 laptop:ml-0 laptop: fullhd: flex-col laptop:justify-around md:order-first md:px-10 sm: order-first ">
        <div class="w-9/10 text-left align-middle laptop:pl-16 laptop:pr-10 md: px-4 md:my-10 sm: mb-0 sm: mt-10 sm: py-4 sm: pl-4">
          <MARSTitle margin-bottom="mb-3 lg:mb-12"><div v-html="$t('animation.easy-2')" /></MARSTitle>
          <p class="md:font-medium  sm: font-medium md:text-lg align-middle laptop:text-slg laptop:leading-7 md:leading-8 sm: leading-6.5" v-html="$t('animation.easy-description-2')" />
        </div>
      </div>
    </div>

    <div class="container align-middle mx-auto flex flex-col laptop:flex-row">
      <div class="w-full flex laptop:w-6/12 laptop:ml-0 laptop: fullhd: flex-col laptop:justify-around md:px-10 ">
        <div class="w-9/10 text-left align-middle laptop:pl-16 laptop:pr-10 md: px-4 sm:mt-10 mb-0 sm:py-4 sm: pl-4">
          <MARSTitle margin-bottom="mb-3 xl:mb-12"><div v-html="$t('animation.more-info')" /></MARSTitle>
        </div>
      </div>

      <div class="w-full flex laptop:w-6/12 laptop:ml-0 laptop: fullhd: flex-col laptop:justify-center md:px-10">
        <div class="w-9/10 text-left align-middle laptop:pl-16 laptop:pr-10 md: px-4 md:mb-10 mb-0 py-4 pl-4">
          <p class="md:font-medium  sm: font-medium md:text-lg align-middle laptop:text-slg laptop:leading-7 md:leading-8 sm: leading-6.5" v-html="$t('animation.check-feature')" />
          <ActionButton :href="$t('links.guide-animation')" :value="$t('how.guide')" bg="highlight" fg="white" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import MARSHeading from '@/components/MARSHeading.vue'
import MARSTitle from '@/components/MARSTitle.vue'
import ActionButton from '@/components/ActionButton.vue'
export default defineNuxtComponent({
  components: { MARSTitle, MARSHeading, ActionButton },
})
</script>

<style scoped>
video::-webkit-media-controls {
    display:none !important;
}
</style>
